<template>
  <default-layout>
     <v-layout wrap>
         <v-flex xs12>
             <settings-menu-bar></settings-menu-bar>
         </v-flex>

         <v-flex xs12>
             <new-package></new-package>
         </v-flex>
         
          <v-flex xs12 class="pt-5">
             <packages-table :packages="packages"></packages-table>
          </v-flex>
     </v-layout>
  </default-layout>
</template>


<script>
import SettingsMenuBar from './_components/settings_menu.vue'
import NewPackage from './_components/packages/new_package.vue'
import PackagesTable from './_components/packages/packages_table.vue'
export default {
  name: 'SettingsIndexPage',
  components: {
    SettingsMenuBar,
    NewPackage,
    PackagesTable
  },
  data () {
    return {
     packages: []
    }
  },
  methods: {
    // async fetchData () {
    //   const { fundis, state } = await this.$store.dispatch('get', '/fundi/select/all')
    //   console.log('fundis', fundis)
    //   this.fundis = fundis;
    // }
  },
  created () {
    this.$store.dispatch('get', '/packages/admin/packages').then((res)=>{
      this.packages = res.packages;
    })
  }
}
</script>
